module.exports = __webpack_public_path__ + "img/trackd-icon-outline.28964d94.svg";